module.exports = __webpack_public_path__ + "img/flightschedule.c88bcb2c.svg";